import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import axios from "../../API/axios";
import toast from "react-hot-toast";
import moment from "moment";
import { customStyles } from "../../selectStyles";
import ReactSelect from "react-select";
import { useSelector, useDispatch } from "react-redux";
import { fetchIndustryData } from "../../redux/actions/industryActions";
import { fetchCompanyCategories, } from "../../redux/actions/companyCategoryActions";
import { fetchCompanySizeData } from "../../redux/actions/companySizeActions";
import { clearCityList, fetchCityData } from "../../redux/actions/citiesAction";
import { useNavigate } from "react-router-dom";

const UpdateRecruiterProfile = () => {
	const navigate = useNavigate();
	const sessionId = localStorage.getItem("sessionId");
	const userUID = localStorage.getItem("userUID");
	const userType = localStorage.getItem("userType");
	const [displays, setDisplays] = useState(false);
	// ...............................Industry DDL....................................... 
	const [industryId, setIndustryId] = useState(null);
	const dispatch = useDispatch();
	const { industryList } = useSelector(
		(state) => state.industry
	);
	useEffect(() => {
		dispatch(fetchIndustryData());
	}, [dispatch]);
	const handleIndustrySelect = (val) => {
		if (val) {
			setIndustryId(val.value);
		} else {
			setIndustryId(null);
		}
	};
	// ...............................Industry DDL.......................................

	// ...............................Company Category DDL.......................................

	const [companyCategoryId, setCompanyCategoryId] = useState(null);
	const [companyCategoryName, setCompanyCategoryName] = useState("");
	const { categories } = useSelector(
		(state) => state.companyCategory
	);
	useEffect(() => {
		dispatch(fetchCompanyCategories());
	}, [dispatch]);
	const handleCompanySelect = (selectedOption) => {
		if (selectedOption) {
			setCompanyCategoryId(selectedOption.value);
		} else {
			setCompanyCategoryId(null);

		}
	};

	// ...............................Company Category DDL.......................................

	// ...............................Company Size DDL.......................................

	const [companySizeId, setCompanySizeId] = useState(null);
	const [companySizeName, setCompanySizeName] = useState("");
	const { companySizes, selectedCompanySizeId } = useSelector(
		(state) => state.companySize
	);
	useEffect(() => {
		dispatch(fetchCompanySizeData());
	}, [dispatch]);
	const handleCompanySizeSelect = (selectedOption) => {
		if (selectedOption) {
			setCompanySizeId(selectedOption.value);
		} else {
			setCompanySizeId(null);
		}
	};
	// ...............................Company Size DDL.......................................

	// ...............................City Dropdown.......................................
	const [cityId, setcityId] = useState(null);
	const { cityList, loading } = useSelector((state) => state.cities);
	useEffect(() => {
		dispatch(fetchCityData());
		// return () => {
		// 	dispatch(clearCityList())
		// }
	}, [dispatch]);
	const handleCityInputChange = (inputValue) => {
		//console.log("Check Reqruiter profile input==>",inputValue);

		dispatch(fetchCityData(inputValue));
	};

	const options = loading
		? [{ label: "Loading...", value: "" }]
		: cityList;

	const handleCitySelect = (selectedOption) => {
		if (selectedOption) {
			setcityId(selectedOption.value);
		} else {
			setcityId(null);

		}
	};
	// ...............................City Dropdown.......................................

	// ...............................PROFILE Start.......................................
	const [emailValue, setEmailValue] = useState("");
	const [contactNoValue, setContactNoValue] = useState("");
	const [websiteValue, setWebsiteValue] = useState("");
	const [taglineValue, setTaglineValue] = useState("");
	const [aboutValue, setAboutValue] = useState("");
	const [descriptionValue, setDescriptionValue] = useState("");
	const [addressValue, setAddressValue] = useState("");
	const [startDate, setStartDate] = useState("");
	const [profileImage, setProfileImage] = useState(null);
	const [profileImageView, setProfileImageView] = useState(null);
	const [error, setError] = useState(null);


	const handleProfileImageChange = (event) => {
		const selectedFile = event.target.files[0];
		const validImageTypes = ['image/jpeg', 'image/png', 'image/jpg'];

		if (selectedFile) {
			// Validate file type
			if (!validImageTypes.includes(selectedFile.type)) {
				setError('Only JPEG and PNG images are allowed.');
				setProfileImage(null);
				setProfileImageView(null);
				return;
			}

			// Validate file size (limit to 2MB)
			const maxSizeInMB = 10;
			if (selectedFile.size > maxSizeInMB * 1024 * 1024) {
				setError(`File size should not exceed ${maxSizeInMB}MB.`);
				setProfileImage(null);
				setProfileImageView(null);
				return;
			}

			// If valid, update the state
			setProfileImage(selectedFile);
			setProfileImageView(URL.createObjectURL(selectedFile));
			setError(null);
		}
	};



	// ...............................Get PROFILE Start.......................................
	const [formChanged, setFormChanged] = useState(false); // Track if form is modified
	const [isSubmitting, setIsSubmitting] = useState(false);
	// Handle changes and mark form as modified
	const handleFieldChange = (setter, value) => {
		setter(value);
		setFormChanged(true); // Enable Submit button
	};

	// const Comapny = async (e) => {
	// 	e.preventDefault();
	// 	try {
	// 		setDisplays(true);
	// 		setIsSubmitting(true); // Disable the button during submission
	// 		if (!contactNoValue || contactNoValue.length < 10 || contactNoValue.length > 12) {
	// 			toast.error("Contact number must be between 10 and 12 digits!");
	// 			setDisplays(false);
	// 			return;
	// 		}
	// 		if (
	// 			emailValue &&
	// 			contactNoValue &&
	// 			websiteValue &&
	// 			taglineValue &&
	// 			aboutValue &&
	// 			descriptionValue &&
	// 			companyCategoryId &&
	// 			industryId &&
	// 			companySizeId &&
	// 			addressValue &&
	// 			cityId &&
	// 			startDate &&
	// 			profileImage !== ""
	// 		) {
	// 			const formData = new FormData();
	// 			formData.append("Email", emailValue);
	// 			formData.append("ContactNo", contactNoValue);
	// 			formData.append("Website", websiteValue);
	// 			formData.append("Description", descriptionValue);
	// 			formData.append("Tagline", taglineValue);
	// 			formData.append("About", aboutValue);
	// 			formData.append("CompanyCategoryId", companyCategoryId);
	// 			formData.append("IndustryId", industryId);
	// 			formData.append("CompanySizeId", companySizeId);
	// 			formData.append("Address", addressValue);
	// 			formData.append("CityId", cityId);
	// 			formData.append(
	// 				"IncorpDate",
	// 				startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
	// 			);
	// 			formData.append("LogoImage", profileImage);
	// 			formData.append("SessionId", sessionId);

	// 			const res = await axios.post(
	// 				"/Account/UpdateCompanyProfile",
	// 				formData,
	// 				{
	// 					headers: {
	// 						"Content-Type": "multipart/form-data",
	// 					},
	// 				}
	// 			);
	// 			navigate(`/${userType}/${userUID}`);
	// 			// navigate(`/Resume/Recruiter?userUID=${userUID}`);
	// 			toast.success(res.data.message);
	// 			setDisplays(false);
	// 		} else {
	// 			toast.error("please enter required fields!");
	// 			setIsSubmitting(false); // Re-enable the button if validation fails
	// 		}
	// 	} catch (error) {
	// 		if (error.response && error.response.status === 404) {
	// 			toast.error(error.response.data.message);
	// 		} else {
	// 			toast.error(error.response?.data?.message || "An error occurred");
	// 		}
	// 	} finally {
	// 		setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
	// 	}
	// };

	// const Comapny = async (e) => {
	// 	e.preventDefault();
	// 	try {

	// 		const urlPattern = /^(https?:\/\/|www\.)[\w\d.-]+\.[a-zA-Z]{2,}(:[0-9]+)?(\/.*)?$/;
	// 		if (websiteValue && !urlPattern.test(websiteValue)) {
	// 			toast.error("Please enter a valid Test Link!");
	// 			return;
	// 		}
	// 		setDisplays(true);
	// 		setIsSubmitting(true); // Disable the button during submission


	// 		if (!contactNoValue || contactNoValue.length < 10 || contactNoValue.length > 12) {
	// 			toast.error("Contact number must be between 10 and 12 digits!");
	// 			setDisplays(false);
	// 			return;
	// 		}

	// 		const formData = new FormData();
	// 		formData.append("Email", emailValue);
	// 		formData.append("ContactNo", contactNoValue || "");
	// 		formData.append("Website", websiteValue || "");
	// 		formData.append("Description", descriptionValue || "");
	// 		formData.append("Tagline", taglineValue || "");
	// 		formData.append("About", aboutValue || "");
	// 		formData.append("CompanyCategoryId", companyCategoryId);
	// 		formData.append("IndustryId", industryId);
	// 		formData.append("CompanySizeId", companySizeId);
	// 		formData.append("Address", addressValue || "");
	// 		formData.append("CityId", cityId);
	// 		formData.append(
	// 			"IncorpDate",
	// 			startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
	// 		);
	// 		//formData.append("LogoImage", profileImage);
	// 		if (profileImage) {
	// 			formData.append("LogoImage", profileImage);
	// 		}
	// 		formData.append("SessionId", sessionId);

	// 		const res = await axios.post(
	// 			"/Account/UpdateCompanyProfile",
	// 			formData,
	// 			{
	// 				headers: {
	// 					"Content-Type": "multipart/form-data",
	// 				},
	// 			}
	// 		);

	// 		// navigate(`/${userType}/${userUID}`);
	// 		toast.success(res.data.message);
	// 	} catch (error) {
	// 		if (error.response && error.response.status === 404) {
	// 			toast.error(error.response.data.message);
	// 		} else {
	// 			toast.error(error.response?.data?.message);
	// 		}
	// 	} finally {
	// 		setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
	// 		setDisplays(false);
	// 	}
	// };


	const Comapny = async (e) => {
		e.preventDefault();
		try {

			const urlPattern = /^(https?:\/\/|www\.)[\w\d.-]+\.[a-zA-Z]{2,}(:[0-9]+)?(\/.*)?$/;
			if (websiteValue && !urlPattern.test(websiteValue)) {
				toast.error("Please enter a valid Test Link!");
				return;
			}


			setDisplays(true);
			setIsSubmitting(true);
			if (!contactNoValue || contactNoValue.length < 10 || contactNoValue.length > 12) {
				toast.error("Contact number must be between 10 and 12 digits!");
				setDisplays(false);
				return;
			}
			if (
				emailValue &&
				contactNoValue &&
				// aboutValue &&
				// // websiteValue &&
				// // taglineValue &&
				// // descriptionValue &&
				companyCategoryId &&
				industryId &&
				cityId &&
				// profileImage &&
				// startDate &&
				// addressValue &&
				companySizeId
				!== ""
			) {
				const formData = new FormData();
				formData.append("Email", emailValue);
				formData.append("ContactNo", contactNoValue);
				formData.append("Website", websiteValue || "");
				formData.append("Description", descriptionValue || "");
				formData.append("Tagline", taglineValue || "");
				formData.append("About", aboutValue || "");
				formData.append("CompanyCategoryId", companyCategoryId);
				formData.append("IndustryId", industryId);
				formData.append("CompanySizeId", companySizeId);
				formData.append("Address", addressValue || "");
				formData.append("CityId", cityId);
				formData.append(
					"IncorpDate",
					startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
				);
				//formData.append("LogoImage", profileImage);


				if (profileImage) {
					formData.append("LogoImage", profileImage);
				}

				formData.append("SessionId", sessionId);
				const res = await axios.post(
					"/Account/UpdateCompanyProfile",
					formData,
					{
						headers: {
							"Content-Type": "multipart/form-data",
						},
					}
				);
				// localStorage.setItem("profilPic", profileImage);
				// window.dispatchEvent(new Event("profileImageUpdated"));
				// navigate(`/${userType}/${userUID}`);

				toast.success(res.data.message);
				window.location.reload();
				setDisplays(false);
				// setImageChanged(false);
			} else {
				toast.error("please enter required fields!");
				setIsSubmitting(false); // Re-enable the button if validation fails
				// { position: "top-center" }
			}
		} catch (error) {
			if (error.response && error.response.status === 404) {
				toast.error(error.response.data.message);
			} else {
				toast.error(error.response?.data?.message);
			}
		} finally {
			setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
		}
	};


	const [profileData, setProfileData] = useState("");
	const GetProfile = async () => {
		try {
			const res = await axios.get(
				`/Company/GetProfile?UID=${userUID}&CompType=Recruiter`
			);
			setProfileData(res.data.responseData);
			console.log("=====>", res.data.responseData);
			const userData = res.data.responseData;
			localStorage.setItem("name", userData.name);
			localStorage.setItem("startedDate", userData.startedDate);
			localStorage.setItem("compType", userData.compType);
			localStorage.setItem("cityName", userData.cityName);
			localStorage.setItem("email", userData.email);
			localStorage.setItem("profilPic", userData.logoImage);
		} catch (error) {
			console.log("error", error);
		}
	};
	useEffect(() => {
		GetProfile();
	}, []);
	console.log("res", profileData);

	useEffect(() => {
		if (profileData) {
			setEmailValue(profileData?.email);
			setContactNoValue(profileData?.contactNo);
			setWebsiteValue(profileData?.website);
			setTaglineValue(profileData?.tagline);
			setAboutValue(profileData?.about);
			setDescriptionValue(profileData?.description);
			setAddressValue(profileData?.address)

			setcityId(profileData?.cityId);
			dispatch(fetchCityData(profileData?.cityName));

			setStartDate(profileData?.startedDate);
			setProfileImageView(profileData?.logoImage);

			setIndustryId(profileData?.industryID);

			setCompanySizeId(profileData?.companySizeID)
			setCompanySizeName(profileData?.companySize)

			setCompanyCategoryId(profileData?.companyCategoryID)
			setCompanyCategoryName(profileData?.companyCategory)
			if (profileData?.logoImage) {
				fetch(profileData.logoImage)
					.then(response => response.blob())
					.then(blob => {
						const file = new File([blob], profileData.logoImage.split('/').pop(), { type: blob.type });
						setProfileImage(file);
					})
					.catch(error => console.error("Error fetching image:", error));
			}
		}
	}, [profileData]);

	// ...............................Get PROFILE End.......................................
	return (
		<>
			{/* <h6 className="f-600">Profile Setting</h6> */}

			<div className="profile-setting-form">
				<div className="form-row">
					<div className="form-group text-transform-email email-label-category">
						<label htmlFor="companymail">Recruiter email </label>
						<input
							type="text"
							id="companymail"
							className="form-control Dark-Input-from-group"
							required
							// onChange={(e) => setEmailValue(e.target.value)}
							onChange={(e) => handleFieldChange(setEmailValue, e.target.value)}
							value={emailValue}
							invalid={displays && emailValue === ""}
							disabled
						/>
						{displays && !emailValue ? (
							<span className="error_msg_lbl text-red">Enter email </span>
						) : null}
					</div>

					{/* <div className="form-group text-transform-email email-label-category">
						<label htmlFor="companymail">Recruiter email</label>
						<input
							type="text"
							id="companymail"
							className="form-control Dark-Input-from-group"
							required
							// onChange={(e) => setEmailValue(e.target.value)}
							onChange={(e) => handleFieldChange(setEmailValue, e.target.value)}
							value={emailValue}
							invalid={displays && emailValue === ""}
							disabled
						/>
						{displays && !emailValue ? (
							<span className="error_msg_lbl text-red">Enter email </span>
						) : null}
					</div> */}


					<div className="form-group">
						<label htmlFor="contact">Contact no <span className="text-red">*</span></label>
						<input
							type="tel"
							maxLength={12}
							id="contact"
							className="form-control Dark-Input-from-group"
							required
							// onChange={(e) => setContactNoValue(e.target.value)}
							onChange={(e) => handleFieldChange(setContactNoValue, e.target.value)}
							value={contactNoValue}
							invalid={displays && contactNoValue === ""}
						/>
						{displays && !contactNoValue ? (
							<span className="error_msg_lbl text-red">Enter number </span>
						) : null}
					</div>
				</div>


				<div className="form-row">
					<div className="form-group">
						<label htmlFor="CompanySizeId">Company size <span className="text-red"> *</span> </label>
						<ReactSelect
							options={companySizes}
							// onChange={handleCompanySizeSelect}
							onChange={(option) => handleFieldChange(setCompanySizeId, option ? option.value : "")}
							value={
								companySizes.find((option) => option.value === companySizeId) ||
								null
							}
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control"
							isClearable
						/>
						{displays && !companySizeId ? (
							<span className="error_msg_lbl text-red">
								Select company size
							</span>
						) : null}
					</div>
					<div className="form-group">
						<label htmlFor="city">City <span className="text-red">*</span></label>
						<ReactSelect
							options={options}
							// onChange={handleCitySelect}
							onChange={(options) => handleFieldChange(setcityId, options ? options.value : "")}
							value={
								cityList.find((option) => option.value === cityId) ||
								null
							}
							onInputChange={handleCityInputChange}
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control"
							isClearable
						/>
						{displays && !cityId ? (
							<span className="error_msg_lbl text-red">Search & select city</span>
						) : null}
					</div>
				</div>
				<div className="form-row">
					<div className="form-group">
						<label htmlFor="website">Company category <span className="text-red">*</span></label>
						<ReactSelect
							options={categories}
							// onChange={handleCompanySelect}
							onChange={(option) => handleFieldChange(setCompanyCategoryId, option ? option.value : "")}
							value={
								categories.find(
									(option) => option.value === companyCategoryId
								) || null
							}
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control"
							isClearable
						/>
						{displays && !companyCategoryId ? (
							<span className="error_msg_lbl text-red">
								Select company category
							</span>
						) : null}
					</div>

					<div className="form-group">
						<label htmlFor="tagline">Industry <span className="text-red">*</span></label>

						<ReactSelect
							options={industryList}
							// onChange={handleIndustrySelect}
							onChange={(option) => handleFieldChange(setIndustryId, option ? option.value : "")}
							value={
								industryList.find(
									(option) => option.value === industryId
								) || null
							}
							styles={customStyles}
							classNamePrefix="react-select"
							className="form-control"
							isClearable
						/>

						{displays && !industryId ? (
							<span className="error_msg_lbl text-red">Select industry</span>
						) : null}
					</div>
				</div>

				<div className="form-row">
					<div className="form-group text-transform-email">
						<label htmlFor="CompanyCategoryId">Website</label>
						<input
							type="text"
							id="contact"
							className="form-control Dark-Input-from-group"
							required
							onChange={(e) => setWebsiteValue(e.target.value)}
							// onChange={(e) => handleFieldChange(setWebsiteValue, e.target.value)}
							value={websiteValue}
							invalid={displays && websiteValue === ""}
						/>
					</div>

					<div className="form-group">
						<label htmlFor="IndustryId">Tagline </label>
						<input
							type="text"
							id="contact"
							className="form-control Dark-Input-from-group"
							required
							// onChange={(e) => setTaglineValue(e.target.value)}
							onChange={(e) => handleFieldChange(setTaglineValue, e.target.value)}
							value={taglineValue}
							invalid={displays && taglineValue === ""}
						/>
						{/* {displays && !taglineValue ? (
						  <span className="error_msg_lbl text-red">Enter Tagline </span>
						) : null} */}
					</div>
				</div>


				<div className="form-row">


					<div className=" form-group">
						<label htmlFor="IncorpDate">Incorporate date</label>
						<Flatpickr
							type="number"
							id="dob"
							className="form-control Dark-Input-from-group"
							required
							// onChange={(date) => setStartDate(date[0])}
							onChange={(date) => handleFieldChange(setStartDate, (date[0]))} // Track changes
							value={startDate}
							invalid={displays && startDate === ""}
							options={{
								maxDate: new Date()
							}}
						/>
						{displays && !startDate ? (
							<span className="error_msg_lbl text-red">Enter date </span>
						) : null}
					</div>

					<div className=" form-group">
						<label htmlFor="ProfileImg">Logo image</label>
						<input
							type="file"
							id="ProfileImg"
							className="form-control Dark-Input-from-group"
							required
							accept="image/jpeg, image/png, image/jpg"
							// onChange={handleProfileImageChange}
							onChange={(e) => {
								const selectedFile = e.target.files[0];
								if (!selectedFile) return;

								handleFieldChange(setProfileImage, selectedFile);

								// ✅ Convert file to Object URL for immediate preview
								const imageURL = URL.createObjectURL(selectedFile);
								setProfileImageView(imageURL);
								// setImageChanged(true);
								// ✅ Convert file to Base64 and save it in localStorage
								const reader = new FileReader();
								reader.onloadend = () => {
									const base64Image = reader.result;
									localStorage.setItem("profilPic", base64Image);

								};

								reader.readAsDataURL(selectedFile);
							}}
							style={{ height: '56px', paddingTop: '15px' }}
						/>

						{error && <span className="error_msg_lbl text-red">{error}</span>}
						{profileImageView && (
							<div className="d-flex justify-content-center " style={{ width: '75px', height: '75px' }}>
								<img
									src={profileImageView}
									alt="Profile Preview"
									// width={100}
									// height={100}
									className="mt-2 rounded-circle"
								// style={{ borderRadius: '50%' }}
								/>
							</div>

						)}
					</div>

				</div>


				<div className="form-group">
					<label htmlFor="About">About</label>
					<textarea
						type="text"
						className="form-control Dark-Input-from-group"
						required
						// onChange={(e) => setAboutValue(e.target.value)}
						onChange={(e) => handleFieldChange(setAboutValue, e.target.value)}
						value={aboutValue}
						invalid={displays && aboutValue === ""}
					></textarea>
					{/* {displays && !aboutValue ? (
						<span className="error_msg_lbl text-red">Write About </span>
					  ) : null} */}
				</div>
				<div className="form-group mt-3">
					<label htmlFor="Description">Description</label>
					<textarea
						type="text"
						className="form-control Dark-Input-from-group"
						required
						// onChange={(e) => setDescriptionValue(e.target.value)}
						onChange={(e) => handleFieldChange(setDescriptionValue, e.target.value)}
						value={descriptionValue}
						invalid={displays && descriptionValue === ""}
					></textarea>
					{/* {displays && !descriptionValue ? (
						<span className="error_msg_lbl text-red">Enter Description </span>
					  ) : null} */}
				</div>
				<div className="form-group mt-3">
					<label htmlFor="Address">Address</label>
					<textarea
						type="text"
						className="form-control Dark-Input-from-group"
						required
						// onChange={(e) => setAddressValue(e.target.value)}
						onChange={(e) => handleFieldChange(setAddressValue, e.target.value)}
						value={addressValue}
						invalid={displays && addressValue === ""}
					></textarea>
					{/* {displays && !addressValue ? (
						<span className="error_msg_lbl text-red">Enter Address </span>
					  ) : null} */}
				</div>

				<button
					//  className="btn btn-primary" 
					onClick={Comapny}
					className="btn btn-primary"
				// onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
				// disabled={!formChanged || isSubmitting}
				// style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
				>
					Update
				</button>
			</div>


		</>
	);
};

export default UpdateRecruiterProfile;
